import React, { useContext } from "react";
import { LangContext } from "../../../../context/DataContext";  
import Resumen from "./Resumen";
import Introduccion from "./Introduccion";
import Metodologia from "./Metodologia";
import DatosPorPais from "./DatosPorPais"
import AnalisisRegional from './AnalisisRegional';
import Conclusiones from './Conclusiones';
import Referencias from './Referencias'; 

export default function InterconexionBgp() {
 
    return ( 
      <> 
        <ReportTitle />
        <Resumen /> 
        <Introduccion /> 
        <Metodologia /> 
        <DatosPorPais /> 
        <AnalisisRegional /> 
        <Conclusiones /> 
        <Referencias />  
      </>
    )
}
 
function ReportTitle() {
  const { myLang } = useContext(LangContext)
  return (
    <h1>
        {myLang === 'es' && 'Interconexión en BGP en la región de América Latina y el Caribe'}
        {myLang === 'en' && 'BGP Interconnection in the Region of Latin America and the Caribbean'}
        {myLang === 'pt' && 'Interconexão no BGP na região da América Latina e o Caribe'}
    </h1>
    )
}
 